
import React, { useState } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { FaLinkedin, FaEnvelope, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const TeamPage = () => {
  // Function to handle navigation to homepage with section scrolling
  const handleNavigation = (sectionId) => {
    // Store the section ID in sessionStorage
    sessionStorage.setItem('scrollToSection', sectionId);
    // Navigate to homepage
    window.location.href = '/';
  };

  const leadershipTeam = [
    {
      name: 'Richa K Mishra',
      role: 'CEO',
      image: 'https://linkinprofessionals.com/images/richa.JPG',
      bio: 'Chief Executive Officer leading Vlinkin Professionals towards excellence in corporate training',
      email: 'richa@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/richa-mishra-6ba12744/',
      profileDetails: `
        <div class="text-gray-600 text-sm leading-relaxed">
          <p class="mb-4">
            Richa Mishra is a dynamic Chief Operating Officer at ACS with over 16 years of diverse experience in higher education, e-learning, and technology services. She holds a Ph.D. in English, along with postgraduate qualifications in Mass Communication and Business Management from XLRI.
          </p>
          <p class="mb-4">
            She began her career at Dayanand Sagar College of Engineering, contributing to teaching, mentoring, and academic development. Known for her leadership and communication skills, she specializes in optimizing operations, driving strategic initiatives, and enhancing organizational performance. At ACS, she plays a key role in strengthening operations and delivering impactful business outcomes.
          </p>
        </div>
      `
    },
    {
      name: 'Jagamani J',
      role: 'Senior Administrator',
      image: 'https://linkinprofessionals.com/images/jagamani.jpeg',
      bio: 'Senior Administrator managing day-to-day operations and administrative excellence',
      email: 'jagamani@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/jagamani-j',
      profileDetails: `
        <div class="text-gray-600 text-sm leading-relaxed">
          <p class="mb-4">
            Jagamani has over 12 years of experience in administrative management and operations. She is known for her exceptional organizational skills and ability to streamline processes.
          </p>
        </div>
      `
    },
    {
      name: 'Sandra Xavier',
      role: 'Asst. Manager HR-Ops and Client Relationship',
      image: 'https://linkinprofessionals.com/images/Sandra.JPG',
      bio: 'Managing HR operations and building strong client relationships',
      email: 'sandra@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/sandra-xavier-b4a1b6213/',
      profileDetails: `
        <div class="text-gray-600 text-sm leading-relaxed">
          <p class="mb-4">
            Sandra has 4 years of experience in HR operations, talent management, and employee relations, with a strong focus on improving employee engagement and operational efficiency. She previously worked at Impelsys, where she contributed to HR strategies supporting business growth and a positive work culture. Currently, as Manager - HR Operations and Client Engagement at Amossys Consulting Services, she oversees recruitment, onboarding, and performance management, delivering effective HR solutions aligned with organizational goals.
          </p>
        </div>
      `
    },
    {
      name: 'Simona D Fernandes',
      role: 'Talent Acquisition & Human Capital Manager',
      image: 'https://linkinprofessionals.com/images/Simona.JPG',
      bio: 'Leading talent acquisition and human capital management initiatives',
      email: 'simona@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/simona-denise-fernandes/',
      profileDetails: `
        <div class="text-gray-600 text-sm leading-relaxed">
          <p class="mb-4">
            Simona Denise Fernandes is a skilled HR professional with over 5 years of experience in global talent acquisition, diversity hiring, and employer branding across multiple industries. She began her career at TCS, gaining expertise in campus and lateral hiring, and has since led international recruitment initiatives. Currently serving as Talent Acquisition and Human Capital Manager, she drives global hiring strategies, employee engagement, and talent alignment with business goals. Recognized for her achievements at national and international platforms, Simona is passionate about building inclusive workplaces and advancing strategic HR initiatives.
          </p>
        </div>
      `
    },
    {
      name: 'Bhagyalakshmi Kaipa',
      role: 'Talent Acquisition Manager',
      image: 'https://linkinprofessionals.com/images/bhagyalakshmi.jpg',
      bio: 'Managing talent acquisition and recruitment strategies',
      email: 'bhagyalakshmi@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/bhagyalakshmi-kaipa-ba502421b/',
      profileDetails: `
        <div class="text-gray-600 text-sm leading-relaxed">
          <p class="mb-4">
            Bhagyalakshmi Kaipa is a Talent Acquisition Manager with 10+ years of experience in end-to-end recruitment, specializing in strategic hiring, stakeholder management, and building strong talent pipelines across multiple domains. She has a proven track record of partnering with business leaders to deliver quality hires and support organizational growth through effective recruitment strategies.
Previously at IBM, she was responsible for leadership hiring and end-to-end recruitment for key roles, working closely with senior stakeholders to attract top talent. Throughout her career, she has been recognized for her contributions with multiple awards, including two DNA Awards at Sonata Software, 3000+ Blue Points and a cash award at IBM, and a Spot Award at Amossys.
Bhagyalakshmi holds an MBA in Finance and Marketing and is passionate about connecting people with the right opportunities. Outside of work, she enjoys home décor, building meaningful professional connections, listening to music, and long drives, which help her stay creative and energized.
          </p>
          
        </div>
      `
    }
  ];

  const advisoryBoard = [
    {
      name: 'Ajay Kumar Mishra',
      role: 'CEO, Amossys Consulting Services',
      image: 'https://linkinprofessionals.com/images/ap.JPG',
      bio: 'Strategic advisor with extensive consulting experience',
      email: 'ajay.advisor@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/ajay-mishra-b7328320/',
      profileDetails: `
        <div class="text-gray-600 text-sm leading-relaxed">
          <p class="mb-4">
            Ajay brings over 20 years of experience in the IT industry, with an MBA in Finance. He has worked with leading organizations such as Tata Consultancy Services, HCL Technologies, and Inlaks Computers. With global exposure across Asia, Europe, the Middle East, and Africa, he has expertise in project leadership, pre-sales, training, and support services. At ACS, he is focused on driving innovation and transforming the organization into a globally recognized IT enterprise.
          </p>
        </div>
      `
    }
  ];

  // NOTE: Fill in the real LinkedIn profile URLs below (currently placeholders).
  // Once a valid URL is set, the LinkedIn icon will automatically appear
  // next to the email icon on that member's card — same as the Leadership Team.
  const technicalTeam = [
    {
      name: 'Pankaj Gupta',
      role: 'Team Lead',
      image: 'https://linkinprofessionals.com/images/pankaj.JPG',
      bio: 'Team Lead managing technical operations and training delivery',
      email: 'pankaj@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/erpankajkgupta/' // TODO: replace with real URL
    },
    {
      name: 'Pooja Dey',
      role: 'Service Engineer',
      image: 'https://linkinprofessionals.com/images/Media.jpg',
      bio: 'Service Engineer delivering quality technical solutions',
      email: 'pooja@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/pooja-dey/' // TODO: replace with real URL
    },
    {
      name: 'Vidya K',
      role: 'Junior Software Engineer',
      image: 'https://linkinprofessionals.com/images/Profile Picture.jpeg',
      bio: 'Junior Software Engineer supporting training initiatives',
      email: 'vidya@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/vidya-k/' // TODO: replace with real URL
    },
    {
      name: 'Aditya Prakash',
      role: 'Software Engineer',
      image: 'https://linkinprofessionals.com/images/adithay.jpg',
      bio: 'Software Engineer specializing in full-stack development',
      email: 'aditya@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/aditya-prakash7066/' // TODO: replace with real URL
    },
    {
      name: 'Bhaskar H N',
      role: 'Software Engineer',
      image: 'https://linkinprofessionals.com/images/bhaskar.png',
      bio: 'Software Engineer with strong technical training background',
      email: 'bhaskar@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/bhaskar-hn-666270226/' // TODO: replace with real URL
    },
    {
      name: 'SHREEKANTHA G',
      role: 'Software Engineer',
      image: 'https://linkinprofessionals.com/images/PHOTO.JPG',
      bio: 'Software Engineer with expertise in modern technologies',
      email: 'srikanta@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/shreekantha-g/' // TODO: replace with real URL
    },
    {
      name: 'Lalitha D',
      role: 'Software Engineer',
      image: 'https://linkinprofessionals.com/images/lalitha.jpg',
      bio: 'Software Engineer delivering quality technical training',
      email: 'lalitha@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/lalitha-d-92a8771ba/' // TODO: replace with real URL
    },
    {
      name: 'Aishwarya N',
      role: 'Snr.Software Engineer /Trainer',
      image: 'https://linkinprofessionals.com/images/Aishwarya.jpeg',
      bio: 'Senior Software Engineer and Technical Trainer dedicated to delivering high-quality technical education and engineering excellence.',
      email: 'Aishwarya@linkinprofessionals.com',
      linkedin: 'https://www.linkedin.com/in/aishwarya-n/' // TODO: replace with real URL
    }
  ];

  // Updated TeamMemberCard with expandable profile section
  const TeamMemberCard = ({ member }) => {
    const [expanded, setExpanded] = useState(false);

    return (
      <div className="group relative bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-500 border border-gray-100">
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-600 via-purple-600 to-orange-500"></div>

        <div className="relative">
          <div className="relative h-72 overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
            <img
              src={member.image}
              alt={member.name}
              className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-60 group-hover:opacity-40 transition-opacity duration-300"></div>
            <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full shadow-lg">
              <span className="text-xs font-semibold text-blue-600">Team Member</span>
            </div>
          </div>

          <div className="p-6">
            <div className="mb-4">
              <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                {member.name}
              </h3>
              <div className="flex items-center gap-2 mb-3">
                <div className="h-1 w-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded"></div>
                <p className="text-sm font-semibold text-blue-600 uppercase tracking-wide">
                  {member.role}
                </p>
              </div>
            </div>

            <p className="text-gray-600 text-sm leading-relaxed mb-5 line-clamp-3">
              {member.bio}
            </p>

            {/* Expandable profile section */}
            {member.profileDetails && (
              <>
                <div className={`overflow-hidden transition-all duration-300 ${expanded ? 'max-h-[500px]' : 'max-h-0'}`}>
                  <div className="pb-4" dangerouslySetInnerHTML={{ __html: member.profileDetails }} />
                </div>

                <button
                  onClick={() => setExpanded(!expanded)}
                  className="text-sm text-blue-600 hover:text-blue-800 font-medium transition-colors flex items-center gap-1 mt-2"
                >
                  {expanded ? 'Show Less' : 'View More'}
                  {expanded ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                </button>
              </>
            )}

            <div className="flex items-center gap-3 pt-4 border-t border-gray-100 mt-4">
              <a
                href={`mailto:${member.email}`}
                className="flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
                title={`Email ${member.name}`}
              >
                <FaEnvelope size={16} />
              </a>
              {member.linkedin && (
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-r from-blue-700 to-blue-900 text-white hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300"
                  title="LinkedIn Profile"
                >
                  <FaLinkedin size={16} />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 right-0 w-20 h-20 bg-gradient-to-tl from-blue-100/50 to-transparent rounded-tl-full"></div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section - kept exactly as it was */}
      <section className="relative pt-32 pb-24 bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-500 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block mb-4">
            <span className="px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-semibold border border-white/20">
              Meet the Experts
            </span>
          </div>
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight" data-testid="team-page-title">
            Meet Our{' '}
            <span className="bg-gradient-to-r from-orange-400 via-yellow-400 to-orange-500 bg-clip-text text-transparent">
              Dream Team
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-white/80 max-w-4xl mx-auto leading-relaxed">
            Passionate professionals dedicated to transforming lives through quality education and training
          </p>

          <div className="grid grid-cols-3 gap-8 mt-16 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">13+</div>
              <div className="text-white/70 text-sm">Team Members</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">50+</div>
              <div className="text-white/70 text-sm">Years Combined Experience</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">500+</div>
              <div className="text-white/70 text-sm">Students Mentored</div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white"/>
          </svg>
        </div>
      </section>

      {/* Leadership Team */}
      <section className="py-24 bg-gradient-to-b from-white to-gray-50" data-testid="leadership-team-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <div className="inline-block mb-4">
              <span className="px-4 py-2 bg-blue-100 text-blue-600 rounded-full text-sm font-semibold">
                Leadership
              </span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Our{' '}
              <span className="bg-gradient-to-r from-blue-600 via-purple-600 to-blue-600 bg-clip-text text-transparent">
                Leadership Team
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Experienced leaders driving our mission to build world-class talent and transform the educational landscape
            </p>
            <div className="mt-6 flex items-center justify-center gap-4">
              <div className="h-px w-16 bg-gradient-to-r from-transparent to-blue-600"></div>
              <div className="w-2 h-2 rounded-full bg-blue-600"></div>
              <div className="h-px w-16 bg-gradient-to-l from-transparent to-blue-600"></div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {leadershipTeam.map((member, index) => (
              <TeamMemberCard key={index} member={member} />
            ))}
          </div>
        </div>
      </section>

      {/* Advisory Board */}
      <section className="py-24 bg-gradient-to-br from-orange-50 via-yellow-50 to-orange-50" data-testid="advisory-board-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <div className="inline-block mb-4">
              <span className="px-4 py-2 bg-orange-100 text-orange-600 rounded-full text-sm font-semibold">
                Advisory
              </span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Advisory{' '}
              <span className="bg-gradient-to-r from-orange-500 via-yellow-500 to-orange-600 bg-clip-text text-transparent">
                Board
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Distinguished expert guiding our strategic direction and organizational growth
            </p>
            <div className="mt-6 flex items-center justify-center gap-4">
              <div className="h-px w-16 bg-gradient-to-r from-transparent to-orange-600"></div>
              <div className="w-2 h-2 rounded-full bg-orange-600"></div>
              <div className="h-px w-16 bg-gradient-to-l from-transparent to-orange-600"></div>
            </div>
          </div>

          <div className="max-w-2xl mx-auto">
            {advisoryBoard.map((member, index) => (
              <TeamMemberCard key={index} member={member} />
            ))}
          </div>
        </div>
      </section>

      {/* Technical Team - kept exactly as it was */}
      <section className="py-24 bg-gradient-to-b from-white to-purple-50" data-testid="technical-team-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <div className="inline-block mb-4">
              <span className="px-4 py-2 bg-purple-100 text-purple-600 rounded-full text-sm font-semibold">
                Technical Excellence
              </span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Technical{' '}
              <span className="bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 bg-clip-text text-transparent">
                Team
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Expert software engineers bringing real-world experience and cutting-edge knowledge to training
            </p>
            <div className="mt-6 flex items-center justify-center gap-4">
              <div className="h-px w-16 bg-gradient-to-r from-transparent to-purple-600"></div>
              <div className="w-2 h-2 rounded-full bg-purple-600"></div>
              <div className="h-px w-16 bg-gradient-to-l from-transparent to-purple-600"></div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {technicalTeam.map((member, index) => (
              <TeamMemberCard key={index} member={member} />
            ))}
          </div>
        </div>
      </section>

      {/* Join Our Team CTA - kept exactly as it was */}
      <section className="relative py-24 bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
        </div>

        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block mb-6">
            <span className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm font-semibold border border-white/30">
              Join Us
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
            Want to Join Our Team?
          </h2>
          <p className="text-xl md:text-2xl mb-10 text-white/90 max-w-2xl mx-auto leading-relaxed">
            We're always looking for passionate educators and professionals to join our mission of transforming futures
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => handleNavigation('contact')}
              className="bg-white text-blue-600 px-6 py-3 rounded-lg font-bold hover:shadow-lg transform hover:-translate-y-1 transition-all"
              data-testid="join-team-btn"
            >
              Get In Touch
            </button>

            <button
              onClick={() => handleNavigation('programs')}
              className="border border-white px-6 py-3 rounded-lg font-bold hover:bg-white hover:text-blue-600 transition-all"
            >
              View Programs
            </button>
          </div>

          <div className="mt-16 grid grid-cols-3 gap-8 max-w-2xl mx-auto">
            <div className="text-center">
              <div className="text-3xl mb-2">🎓</div>
              <div className="text-sm text-white/80">Expert Training</div>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">💼</div>
              <div className="text-sm text-white/80">Career Growth</div>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-2">🌟</div>
              <div className="text-sm text-white/80">Team Culture</div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TeamPage;